module.exports = __webpack_public_path__ + "50d272752da8c2e124887ce2b62b76f7.png";